<div class="container px3 pt-3 chatbot-detail-page">
  @if (viewConfig.loading) {
  <app-spinner-fullscreen></app-spinner-fullscreen>
  } @else if (viewConfig.error) {
  <ngb-alert (closed)="viewConfig.setDefault()" type="danger">{{
    viewConfig.error
  }}</ngb-alert>
  } @if (botDetails) {
  <div class="ind-page-title pb-0">
    <div class="row align-items-start align-items-lg-center pb-3 g-2 g-lg-3">
      <div class="col-12 col-lg-6 p-0 m-0 breadcrumb min-w-0">
        <nav
          class="d-flex flex-wrap align-items-baseline"
          aria-label="Chatbot administration breadcrumb navigation"
        >
          <a
            #adminBreadcrumbLink
            routerLink="/admin/users"
            class="breadcrumb-link"
            (keydown.space)="$event.preventDefault(); adminBreadcrumbLink.click()"
            (keydown.enter)="$event.preventDefault(); adminBreadcrumbLink.click()"
          >Admin</a>
          <span class="breadcrumb-divider" aria-hidden="true">></span>
          <a
            #chatbotBreadcrumbLink
            routerLink="/admin/chatbot-management"
            class="breadcrumb-link"
            (keydown.space)="$event.preventDefault(); chatbotBreadcrumbLink.click()"
            (keydown.enter)="$event.preventDefault(); chatbotBreadcrumbLink.click()"
          >Chatbot Management</a>
          <span class="breadcrumb-divider" aria-hidden="true">></span>
          <p class="breadcrumb-current" aria-current="page">{{ botDetails.name }}</p>
        </nav>
        <div class="d-flex align-items-center mt-2 min-w-0">
          <img
            [addAaTags]="'Admin List Icon'"
            src="/icons/bold/admin-list.svg"
          />
          <p
            class="heading ps-2 min-w-0 text-break"
            role="heading"
            aria-level="1"
          >
            {{ botDetails.name }}
          </p>
        </div>
      </div>
      <div class="col-12 col-lg-6 p-0 text-start text-lg-end">
        <div
          class="chatbot-detail-actions d-flex flex-column flex-lg-row flex-wrap gap-2 align-items-stretch align-items-lg-end justify-content-lg-end"
        >
          <app-button
            class="ind-button-md"
            (click)="goBack()"
            (keydown.enter)="goBack()"
            (keydown.space)="goBack()"
            type="secondary"
            label="Back"
          ></app-button>
          <app-button
            class="ind-button-md"
            type="primary"
            label="Manage Documents"
            (keydown.enter)="manage()"
            (keydown.space)="manage()"
            (click)="manage()"
          ></app-button>
        </div>
      </div>
    </div>
  </div>
  <div class="container p-0">
    <div class="bot-info">
      <div class="header">
        <p role="heading" aria-level="2">Chatbot Information</p>
      </div>
      <div class="row g-3">
        <div class="col-12 col-md-4">
          <p class="label">Name</p>
          <p class="value">{{ botDetails.name }}</p>
        </div>
        <div class="col-12 col-md-4">
          <p class="label">Bucket</p>
          <p class="value text-break">{{ botDetails.bucketPath }}</p>
        </div>
        <div class="col-12 col-md-4">
          <p class="label">
            {{ enabledCheckbox ? "Deactivate" : "Activate" }}
          </p>
          <p class="value custom-switch">
            <label class="switch">
              <input
                id="chatbot-activate-checkbox"
                [(ngModel)]="enabledCheckbox"
                type="checkbox"
                [attr.aria-label]="
                  (enabledCheckbox ? 'Deactivate ' : 'Activate ') +
                  (botDetails.name || 'chatbot')
                "
                (ngModelChange)="changeEnableStatus()"
                (keydown)="onChatbotActivateCheckboxKeydown($event)"
              />
              <span class="slider round"></span>
            </label>
          </p>
        </div>
      </div>
    </div>
    <div class="title" role="heading" aria-level="2">Documents</div>
    <div class="row m-0">
      <div class="col-12 p-0">
        <a
          class="doc-search-table-skip"
          href="#chatbot-detail-documents-table"
        >
          Skip to chatbot documents table
        </a>
        <div id="main" class="table-responsive-sm">
          <table
            id="chatbot-detail-documents-table"
            class="table ind-table table-hover"
            tabindex="-1"
          >
            <caption class="visually-hidden">
              Documents in this chatbot knowledge base
            </caption>
            <thead class="ind-table-thead">
              <tr>
                <th scope="col" id="chatbot-main-col-name">Document Name</th>
                <th scope="col" id="chatbot-main-col-preview">
                  Document Preview
                </th>
                <th scope="col" id="chatbot-main-col-status">Status</th>
                <th scope="col" id="chatbot-main-col-actions">Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (document of botDocuments; track document; let index =
              $index) {
              <tr>
                <th
                  scope="row"
                  [attr.id]="'chatbot-main-row-' + index"
                  headers="chatbot-main-col-name"
                >
                  {{ document.name }}
                </th>
                <td
                  [attr.headers]="
                    'chatbot-main-col-preview chatbot-main-row-' + index
                  "
                >
                  <button
                    type="button"
                    class="preview-link"
                    (click)="previewFile(document)"
                    (keydown.enter)="previewFile(document)"
                    (keydown.space)="previewFile(document)"
                    [attr.aria-label]="
                      'Open preview for ' + (document.name || 'document')
                    "
                  >
                    {{ document.documentUrl }}
                  </button>
                </td>
                <td
                  [attr.headers]="
                    'chatbot-main-col-status chatbot-main-row-' + index
                  "
                >
                  {{
                    !document.operationStatus
                      ? "Training"
                      : document.operationErrorCode
                        ? document.operationErrorMessage
                        : "Imported"
                  }}
                </td>
                <td
                  [attr.headers]="
                    'chatbot-main-col-actions chatbot-main-row-' + index
                  "
                >
                  @if (document.operationStatus) {
                  <button
                    type="button"
                    class="btn btn-link p-0 border-0 align-baseline"
                    (click)="markActivateOrInactivate(document)"
                    (keydown.enter)="
                      $event.preventDefault();
                      markActivateOrInactivate(document)
                    "
                    (keydown.space)="
                      $event.preventDefault();
                      markActivateOrInactivate(document)
                    "
                    [attr.aria-label]="
                      'Remove document ' +
                      document.name +
                      ' from knowledge base'
                    "
                  >
                    <img
                      [addAaTags]="
                        'delete document with name ' + document.name
                      "
                      src="/icons/linear/delete.svg"
                      alt=""
                    />
                  </button>
                  }
                </td>
              </tr>
              }
            </tbody>
          </table>
          <div class="ind-table-pagination">
            <div class="row">
              <div class="col-6">
                <label for="chatbot-docs-page-size" class="visually-hidden"
                  >Page Size</label
                >
                <select
                  id="chatbot-docs-page-size"
                  [attr.aria-label]="'Page Size'"
                  class="ind-table-entries"
                  [(ngModel)]="pageSize"
                  (ngModelChange)="refreshData()"
                >
                  <option
                    *ngFor="let pageSize of allPageSizes"
                    [value]="pageSize"
                  >
                    {{ pageSize }} entries
                  </option>
                </select>
              </div>
              <div class="col-6">
                <div class="d-flex justify-content-end mb-2">
                  <small class="p-1">
                    <span *ngIf="collectionSize > 0">
                      Showing {{ (page - 1) * pageSize + 1 }} -
                      {{
                        page * pageSize > collectionSize
                          ? collectionSize
                          : page * pageSize
                      }}
                      entries of {{ collectionSize }}
                    </span>
                    <span *ngIf="collectionSize === 0">
                      No entries to display.
                    </span></small
                  >
                  <ngb-pagination
                    class="d-flex justify-content-end"
                    size="sm"
                    [maxSize]="2"
                    [collectionSize]="collectionSize"
                    [(page)]="page"
                    [pageSize]="pageSize"
                    (pageChange)="refreshData()"
                    aria-label="Pagination navigation"
                  ></ngb-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>
<ng-template #manageDocumentsModal let-modal>
  <div class="modal-header">
    <div class="col-6">
      <div
        [attr.aria-label]="'New User'"
        class="modal-title"
        id="modal-basic-title"
        role="heading"
        aria-level="2"
      >
        Manage Documents for {{ botDetails.name }}
      </div>
    </div>
    <div class="col-6 text-end">
      <app-button
        type="outline-blue"
        class="me-4"
        label="Upload from CPU"
        (click)="triggerFileInput()"
      ></app-button>
      <button
        addAaTags="Close popup"
        type="button"
        class="btn-close"
        (click)="modal.dismiss('Cross click')"
      ></button>
      <input
        type="file"
        id="fileInput"
        [(ngModel)]="selectedFile"
        style="display: none"
        (change)="handleFileInput($event.target)"
      />
    </div>
  </div>
  <div class="modal-body scrollable-modal">
    <a
      class="doc-search-table-skip"
      href="#chatbot-manage-docs-table"
    >
      Skip to manage documents table
    </a>
    <div id="chatbot-manage-table-wrap" class="table-responsive-sm">
      <table
        id="chatbot-manage-docs-table"
        class="table ind-table table-hover"
        tabindex="-1"
      >
        <caption class="visually-hidden">
          Documents available to add to the chatbot knowledge base
        </caption>
        <thead class="ind-table-thead">
          <tr>
            <th scope="col" id="chatbot-manage-col-name">Document Name</th>
            <th scope="col" id="chatbot-manage-col-preview">
              Document Preview
            </th>
            <th scope="col" id="chatbot-manage-col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (document of manageDocuments; track document; let index =
          $index) {
          <tr>
            <th
              scope="row"
              [attr.id]="'chatbot-manage-row-' + index"
              headers="chatbot-manage-col-name"
            >
              {{ document.name }}
            </th>
            <td
              [attr.headers]="
                'chatbot-manage-col-preview chatbot-manage-row-' + index
              "
            >
              <button
                type="button"
                class="preview-link"
                (click)="previewFile(document)"
                [attr.aria-label]="
                  'Open preview for ' + (document.name || 'document')
                "
              >
                {{ document.documentUrl }}
              </button>
            </td>
            <td
              [attr.headers]="
                'chatbot-manage-col-actions chatbot-manage-row-' + index
              "
            >
              <button
                type="button"
                class="btn btn-link p-0 border-0 pe-2 align-baseline"
                (click)="markActivateOrInactivate(document)"
                (keydown.enter)="markActivateOrInactivate(document)"
                (keydown.space)="markActivateOrInactivate(document)"
                [attr.aria-label]="
                  'Add document ' + document.name + ' to knowledge base'
                "
              >
                <img
                  [addAaTags]="
                    'mark active document with name ' + document.name
                  "
                  src="/icons/linear/add-blue.svg"
                  alt=""
                />
              </button>
              <button
                type="button"
                class="btn btn-link p-0 border-0 align-baseline"
                (click)="deleteDocument(document.id)"
                (keydown.enter)="deleteDocument(document.id)"
                (keydown.space)="deleteDocument(document.id)"
                [attr.aria-label]="'Delete document ' + document.name"
              >
                <img [addAaTags]="document.name" src="/icons/linear/delete.svg" alt="" />
              </button>
            </td>
          </tr>
          }
        </tbody>
      </table>
      <div class="ind-table-pagination">
        <div class="row">
          <div class="col-6">
            <label for="chatbot-manage-page-size" class="visually-hidden"
              >Page Size</label
            >
            <select
              id="chatbot-manage-page-size"
              [attr.aria-label]="'Page Size'"
              class="ind-table-entries"
              [(ngModel)]="pageInactiveSize"
              (ngModelChange)="refreshInactiveData()"
            >
              <option
                *ngFor="let pageInactiveSize of allPageSizes"
                [value]="pageInactiveSize"
              >
                {{ pageInactiveSize }} entries
              </option>
            </select>
          </div>
          <div class="col-6">
            <div class="d-flex justify-content-end mb-2">
              <small class="p-1">
                <span *ngIf="collectionInactiveSize > 0">
                  Showing {{ (pageInactive - 1) * pageInactiveSize + 1 }} -
                  {{
                    pageInactive * pageInactiveSize > collectionInactiveSize
                      ? collectionInactiveSize
                      : pageInactive * pageInactiveSize
                  }}
                  entries of {{ collectionInactiveSize }}
                </span>
                <span *ngIf="collectionInactiveSize === 0">
                  No entries to display.
                </span></small
              >
              <ngb-pagination
                class="d-flex justify-content-end"
                size="sm"
                [maxSize]="2"
                [collectionSize]="collectionInactiveSize"
                [(page)]="pageInactive"
                [pageSize]="pageInactiveSize"
                (pageChange)="refreshInactiveData()"
                aria-label="Pagination navigation"
              ></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
